import React from 'react';
import type { FC } from 'react';

import { Permission } from '@admin/components/helpers/permission';
import { useNavigate } from '@admin/hooks/use_navigate';
import { useTitle } from '@admin/hooks/use_title';
import { VEHICLE } from '@admin/libraries/access_control_catalog.generated';
import { client } from '@admin/libraries/apollo';
import { Status, useVehicleCreateMutation, type Vehicle__Input } from '@admin/schema';

import { VehicleForm } from './form';

export const VehicleNew: FC = () => {
  useTitle('New Vehicle');
  const navigate = useNavigate();
  const [execute, { loading, data }] = useVehicleCreateMutation({ client });

  const save = async (input: Vehicle__Input) => {
    const response = await execute({ variables: { input } });
    const vehicle = response?.data?.result?.vehicle;
    if (!vehicle) return;
    navigate(`/vehicles/${vehicle.id}`);
  };
  const error = data?.result?.error;

  return (
    <Permission resource={VEHICLE.resource} action={VEHICLE.actions.create}>
      <VehicleForm save={save} loading={loading} error={error} />
    </Permission>
  );
};
